import { render, staticRenderFns } from "./Project_select.vue?vue&type=template&id=1c5cda56&"
import script from "./Project_select.vue?vue&type=script&lang=js&"
export * from "./Project_select.vue?vue&type=script&lang=js&"
import style0 from "./Project_select.vue?vue&type=style&index=0&id=1c5cda56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports